import React from "react";
import { ReviewsFullBlock } from "tsi-common-react/src/components/ReviewsFullBlock/index";

import { templates } from "@reactivated";

// `brand="Stearns &amp; Foster"` mirrors this site's ProductReviewsTemplate.tsx
// (and the consolidated productPageBody.tsx reviews_full_block dispatch) -- the
// island the legacy `{% react_product_reviews %}` tag mounted for this block.
export const Template = (
    props: templates.ReviewsFullBlockTemplate,
): React.JSX.Element => {
    return (
        <ReviewsFullBlock value={props.value} brand="Stearns &amp; Foster" />
    );
};
